import React from "react";
import InvestmentTable from "./list/SuitabilityList";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const Investment = () => {
  return (
    <div className="list">
      <div className="listContainer">
        <InvestmentTable />
      </div>
    </div>
  );
};

export default Investment;
